import { getExperienceInflowBundleOfferSequences } from 'checkout/lib/experiences/experienceInflowBundle'
import { createSelector } from 'reselect'
import getExperienceItemsView from './itemViews/getExperienceItemsView'
import { isBundledExperienceItem, isLEHotelItem, isBedbankItem, isAccommodationV2Item, isVillaItem } from 'lib/checkout/checkoutUtils'

export const EXPERIENCE_INFLOW_BUNDLE_METADATA = { checkoutExperienceInflowBundle: true }

export const getExperienceInflowBundleOfferIds = createSelector(
  getExperienceItemsView,
  views => [...new Set(views.data.filter(view => view.item.metaData?.checkoutExperienceInflowBundle === true &&
    view.experience.productType !== 'transfer' && view.item.tickets.some(ticket => ticket.count > 0) &&
    !isBundledExperienceItem(view.item) && view.totals.price > 0).map(view => view.item.experienceId))],
)

export const getSelectedExperienceInflowBundleOfferIds = createSelector(
  getExperienceInflowBundleOfferIds,
  (state: App.State) => state.checkout.cart.items,
  (eligibleOfferIds, items) => {
    const sequences = getExperienceInflowBundleOfferSequences(items)
    return sequences ? [...sequences.entries()]
      .filter(([offerId]) => eligibleOfferIds.includes(offerId))
      .sort((first, second) => first[1] - second[1])
      .slice(0, 2)
      .map(([offerId]) => offerId) : []
  },
)

export function hasValidExperienceInflowBundleMetadata(state: App.State): boolean {
  return getExperienceInflowBundleOfferSequences(state.checkout.cart.items) !== undefined
}

export function hasExperienceInflowBundleAccommodation(state: App.State): boolean {
  return state.checkout.cart.items.some(item => isLEHotelItem(item) || isBedbankItem(item) || isAccommodationV2Item(item) || isVillaItem(item))
}

export function hasExperienceInflowBundleComposition(state: App.State): boolean {
  return hasExperienceInflowBundleAccommodation(state) && hasValidExperienceInflowBundleMetadata(state) && getExperienceInflowBundleOfferIds(state).length >= 2
}
